<!-- Product List -->
<product-pill-row [pills]="productsWithMultipleLadders" [activePillId]="selectedProduct?.id"
  (pillSelect)="selectProduct($event)"></product-pill-row>

<!-- Ladders card: header + type cards + gradient bar + suggestions -->
<div *ngIf="!isAllProductsSelected && productsWithMultipleLadders.length > 0 && (visibleLaddersForSelectedProduct.length > 0 || activeLadder || hasSuggestionsDataInProductRating)" class="dashboard-container">

  <!-- Card header: Ladders title + History button -->
  <div class="ladders-header">
    <div class="ladders-title">
      <ion-icon name="radio-button-on-outline" class="ladders-icon"></ion-icon>
      <span>{{ 'LADDERS' | translate }}</span>
    </div>
    <button class="history-link-btn" [class.active]="showHistoryView" (click)="toggleHistoryView()">
      <ion-icon name="time-outline"></ion-icon>
      {{ 'HISTORY' | translate }}
    </button>
  </div>

  <!-- Ladder type cards (replaces tabs) -->
  <div *ngIf="visibleLaddersForSelectedProduct.length > 0" class="ladder-type-cards">
    <div *ngFor="let ladder of visibleLaddersForSelectedProduct"
      class="ladder-type-card"
      [class.active]="ladder.ladderTypeId === activeLadder?.ladderTypeId && visibleLaddersForSelectedProduct.length > 1"
      (click)="selectLadderType(ladder.ladderTypeId)">
      <div class="card-type-label">{{ ladder.ladderTypeName }}</div>
      <div class="card-stage-row">
        <span class="stage-indicator-dot"></span>
        <span class="card-stage-name">{{ ladder.currentStageName || ('NOT_SET' | translate) }}</span>
        <ion-icon *ngIf="ladder.isEditable" name="create-outline" class="card-edit-icon"></ion-icon>
      </div>
    </div>
  </div>

  <div class="dashboard-main-content" [class.history-active]="showHistoryView">

    <!-- Left side: Gradient bar or History (toggled in-place) -->
    <div class="gradient-bar-container" *ngIf="activeLadder && activeLadder.allStages.length > 0">

      <!-- Gradient bar view -->
      <ng-container *ngIf="!showHistoryView; else historyInPlace">
        <div class="custom-gradient-progressbar">
          <div class="progress-bar"></div>

          <!-- Level Labels (bar left, labels right on all breakpoints) -->
          <div class="level-labels">
            <div *ngFor="let level of adoptionLevelsToDisplay; let i = index" class="level-label"
              [class.active-stage-label]="level.stageId === activeLadder?.currentStageId"
              [class.pending-stage-label]="level.stageId === pendingStage?.stageId"
              [class.goal-stage-label]="isGoalStage(level) && !isGoalReached(level) && level.stageId !== pendingStage?.stageId"
              [class.clickable-label]="activeLadder?.isEditable"
              [style.top.%]="adoptionLevelsToDisplay.length > 1 ? (i / (adoptionLevelsToDisplay.length - 1)) * 100 : 50"
              [style.background-color]="level.stageId === activeLadder?.currentStageId ? indicatorColor : null"
              [style.color]="level.stageId === activeLadder?.currentStageId ? 'white' : (isGoalStage(level) && level.stageId !== pendingStage?.stageId ? goalStageColor(level) : null)"
              [title]="isGoalStage(level) ? (('GOAL' | translate) + ': ' + level.stageName) : level.stageName"
              (click)="onStageLabelClick(level)">
              <ion-icon *ngIf="isGoalStage(level) && !isGoalReached(level) && level.stageId !== pendingStage?.stageId" name="radio-button-on-outline" class="goal-stage-icon"></ion-icon>
              <ng-container [ngSwitch]="true">
                <ng-container *ngSwitchCase="isGoalStage(level) && !isGoalReached(level)">{{ 'GOAL' | translate }}: {{ level.stageName }}</ng-container>
                <ng-container *ngSwitchCase="isGoalReached(level)">{{ level.stageName }} ({{ 'GOAL' | translate }})</ng-container>
                <ng-container *ngSwitchDefault>{{ level.stageName }}</ng-container>
              </ng-container>
            </div>
          </div>

        </div>

        <!-- Tap to update hint (below bar) -->
        <span *ngIf="activeLadder?.isEditable && !pendingStage" class="click-to-update-hint">
          <ion-icon name="pencil-outline"></ion-icon>
          {{ 'CLICK_STAGE_TO_UPDATE' | translate }}
        </span>

        <!-- Inline stage confirmation - anchored to the pending stage Y level -->
        <div *ngIf="pendingStage" class="stage-confirm-dialog"
          [style.top.px]="pendingDialogTopPx">
          <p class="confirm-text">
            {{ 'MOVE_FROM' | translate }} <strong>{{ activeLadder?.currentStageName || ('NOT_SET' | translate) }}</strong>
            {{ 'TO' | translate | lowercase }} <strong>{{ pendingStage.stageName }}</strong>?
          </p>
          <div class="confirm-actions">
            <button class="cancel-btn" (click)="cancelStageUpdate()">{{ 'CANCEL' | translate }}</button>
            <button class="confirm-btn" (click)="confirmStageUpdate()">{{ 'CONFIRM' | translate }}</button>
          </div>
        </div>
      </ng-container>

      <!-- History view (in-place, replaces gradient bar) -->
      <ng-template #historyInPlace>
        <div class="history-in-place">

          <!-- Header: Stage history N -->
          <div class="stage-history-header">
            <ion-icon name="time-outline" class="stage-history-icon"></ion-icon>
            <span>{{ 'LADDER_STAGE_HISTORY' | translate }}</span>
            <span *ngIf="historyCount > 0" class="history-count-badge">{{ historyCount }}</span>
          </div>

          <ng-container *ngIf="historyDisplayEntries.length > 0; else noHistoryYet">

            <!-- Desktop: horizontal scrollable timeline (chronological: oldest left → newest right) -->
            <div class="history-timeline-desktop">
              <div class="history-timeline-scroll">
                <div *ngFor="let entry of chronologicalHistoryEntries; let last = last" class="timeline-node">
                  <div class="timeline-stage-label">{{ entry.newStageName }}</div>
                  <div class="timeline-dot-row">
                    <div class="timeline-dot" [style.background]="entry.dotColor"></div>
                    <div *ngIf="!last" class="timeline-connector-line"></div>
                  </div>
                  <div class="timeline-date">{{ entry.changedOn | date:'MMM d - yyyy' }}</div>
                  <span class="timeline-user-chip">{{ entry.changedByUserName }}</span>
                  <div class="timeline-duration">{{ entry.durationLabel }}</div>
                </div>
              </div>
            </div>

            <!-- Mobile: vertical list (reverse chronological: newest top) -->
            <div class="history-list-mobile">
              <div *ngFor="let entry of historyDisplayEntries; let last = last" class="history-list-entry">
                <div class="entry-timeline-col">
                  <div class="entry-dot" [style.background]="entry.dotColor"></div>
                  <div *ngIf="!last" class="entry-connector-line"></div>
                </div>
                <div class="entry-body">
                  <div class="entry-date">{{ entry.changedOn | date:'MMM d, yyyy' }}</div>
                  <div class="entry-transition">
                    <ng-container *ngIf="!entry.previousStageName; else withFrom">
                      <span class="entry-to-pill" [style.background]="entry.dotColor">Started at {{ entry.newStageName }}</span>
                    </ng-container>
                    <ng-template #withFrom>
                      <span class="entry-from-stage">{{ entry.previousStageName }}</span>
                      <span class="entry-arrow">→</span>
                      <span class="entry-to-pill" [style.background]="entry.dotColor">{{ entry.newStageName }}</span>
                    </ng-template>
                  </div>
                  <div class="entry-meta">{{ entry.changedByUserName }} · {{ entry.durationLabel }}</div>
                </div>
              </div>
            </div>

          </ng-container>
          <ng-template #noHistoryYet>
            <div class="history-empty">
              {{ (activeLadder?.currentStageId ? 'LADDER_NO_PREVIOUS_CHANGES' : 'LADDER_NO_CHANGES_YET') | translate }}
            </div>
          </ng-template>
        </div>
      </ng-template>
    </div>

    <!-- Right side: Suggestion data (hidden when history is shown or no data) -->
    <div class="cards-container" *ngIf="!showHistoryView && hasSuggestionsDataInProductRating">
      <div *ngIf="hasSuggestionsDataInProductRating" class="suggestions-section-header">
        {{ 'CONFIGURED_SUGGESTIONS' | translate }}
      </div>
      <ion-list *ngIf="hasSuggestionsDataInProductRating">
        <ng-container *ngFor="let block of suggestionDataToDisplay; trackBy: trackById">
          <ion-item *ngIf="block.items && (block.type === JourneySuggestionType.CONTENT ? block.items?.contentListData?.length > 0 : block.items.length > 0)">
            <div class="block-label">{{ block.categoryName }}</div>
            <div class="content-item-row" *ngIf="block.type === JourneySuggestionType.CONTENT; else inlineItems">
              <div *ngIf="block.items" class="content-item-container">
                <ng-container *ngFor="let contentItem of block.items.contentListData; trackBy: trackById">
                  <div class="content-item-inline" (click)="openDetails(contentItem)">
                    <ion-thumbnail *ngIf="contentItem.thumbnailURL" class="thumbnail small-thumbnail">
                      <img class="thumbnaim-img" io-thumbnail [src]="contentItem.thumbnailURL" />
                    </ion-thumbnail>
                    <ion-text class="value-text-span">{{ contentItem.title }}</ion-text>
                  </div>
                </ng-container>
                <div *ngIf="block.items.valuePopupText" class="popup-text">
                  ({{ block.items.valuePopupText }}
                  <ion-icon class="drop-icon" name="chevron-down-outline" (click)="openPopup($event, block.items.popupListData)"></ion-icon>)
                </div>
              </div>
            </div>
            <ng-template #inlineItems>
              <div class="items-container">
                <ng-container *ngFor="let item of block.items; trackBy: trackById">
                  <span>{{ item.name || item }}</span>
                </ng-container>
              </div>
            </ng-template>
          </ion-item>
        </ng-container>
      </ion-list>
    </div>
  </div>
</div>

<!-- My Territory Performance Widget -->
<div *ngIf="!isAllProductsSelected && productsWithMultipleLadders.length > 0 && (hasPerformanceMetrics || rxTrendsRestricted)" class="territory-performance-container">
  <div class="performance-header">
    <ion-label class="performance-title">{{ 'RX_PERFORMANCE' | translate }}</ion-label>
    <div class="duration-filter" *ngIf="!rxTrendsRestricted">
      <ion-select [(ngModel)]="selectedDuration"
        (ionChange)="onDurationChange()"
        interface="popover"
        [toggleIcon]="'chevron-down-outline'"
        [expandedIcon]="'chevron-down-outline'">
        <ion-select-option *ngFor="let option of durationOptions; trackBy: trackById" [value]="option.value">
          {{ option.label }}
        </ion-select-option>
      </ion-select>
    </div>
  </div>

  <!-- PDRP / restricted-access state -->
  <div *ngIf="rxTrendsRestricted" class="no-data-message">
    {{ rxTrendsRestrictionMessage }}
  </div>

  <div class="performance-metrics" *ngIf="!rxTrendsRestricted">
    <ng-container *ngFor="let metric of performanceMetricsToDisplay; trackBy: trackById">
      <div class="metric-card">
        <div class="metric-value">
          <span class="value">{{ metric.value }}</span>
          <ng-container *ngIf="metric.trendValue !== null; else emptyTrend">
            <span class="trend-value" [ngClass]="{
              'trend-value-positive': metric.trendValue > 0,
              'trend-value-negative': metric.trendValue < 0,
              'trend-value-zero': metric.trendValue === 0
            }">
              <span class="dot" *ngIf="metric.trendValue !== 0">•</span>
              {{ metric.formattedTrendValue }}
              <div *ngIf="metric.trendValue !== 0"
                class="trend-icon"
                [ngClass]="{
                  'trend-icon-positive': metric.trendValue > 0,
                  'trend-icon-negative': metric.trendValue < 0
                }"
                [style.mask-image]="metric.trendValue > 0 ? 'url(assets/imgs/trending-up.svg)' : 'url(assets/imgs/trending-down.svg)'"
                [style.-webkit-mask-image]="metric.trendValue > 0 ? 'url(assets/imgs/trending-up.svg)' : 'url(assets/imgs/trending-down.svg)'">
              </div>
            </span>
          </ng-container>
          <ng-template #emptyTrend>
            <span class="trend-empty"></span>
          </ng-template>
        </div>
        <div class="metric-label">{{ metric.label }}</div>
      </div>
    </ng-container>
  </div>
</div>

<!--
  Rx Trends (OMNI-60746). Contacts only: TRx/NRx/Refills are prescriber
  metrics. Accounts carry direct sales (volume/value) instead.
-->
<rx-trends *ngIf="entityType === 'contact' && (rxTrendsLoading || hasRxTrends || rxTrendsIngestInProgress)"
  [series]="rxTrendsSeries"
  [selectedProductId]="selectedRxSeriesKey"
  [dataAsOfDate]="rxTrendsDataAsOfDate"
  [isLoading]="rxTrendsLoading"
  [isDataComplete]="rxTrendsDataComplete"
  [isSyncing]="rxTrendsIngestInProgress"
  [restricted]="rxTrendsRestricted"
  [restrictionMessage]="rxTrendsRestrictionMessage"
  [productPills]="productsWithMultipleLadders"
  [activePillId]="selectedProduct?.id"
  (pillSelect)="selectProduct($event)">
</rx-trends>

<!-- Offline empty state (no cached data) -->
<div *ngIf="dataLoaded && isOffline && productsWithMultipleLadders.length === 0" class="journey-offline-empty">
  <ion-icon name="cloud-offline-outline" class="offline-empty-icon"></ion-icon>
  <p class="offline-empty-text">{{ 'JOURNEY_DATA_OFFLINE_MSG' | translate }}</p>
</div>

<!-- No products / no data message (online) -->
<div *ngIf="dataLoaded && !isOffline && !rxTrendsLoading && !rxTrendsIngestInProgress && !hasRxTrends && (showEmptyProductMessage || (productsWithMultipleLadders.length > 0 && !visibleLaddersForSelectedProduct.length && !hasSuggestionsDataInProductRating && !hasPerformanceMetrics))"
  class="no-products-container">
  <div class="no-data-message"
    [ngClass]="{'no-data-message-below-product': !showEmptyProductMessage}">
    {{ 'NO_PRODUCTS_ADOPTION_LADDER_RX_SALES_DATA' | translate }}
  </div>
</div>
